import * as React from 'react'
import { connect } from 'react-redux'
import Page from './../components/shared/page'
import './../styles/admin/admin.css'
import axios from 'axios'
import { Link } from 'react-router-dom'
import arrow from './../images/left-arrow-circle.png'
import {toastr} from 'react-redux-toastr'
import './../styles/admin/testScripts.css'
import Spinner from './../components/shared/spinner'
import { Button } from './../components/shared/button'

class TestScripts extends React.Component {

  constructor() {
    super()

    this.state = {
      lastVisit: null,
      lastLogin: null,
      cameraAngles: null,
      isLastVisitDisabled: false,
      isCameraAnglesDisabled: true,
      displayLastVisitSpinner: false,
      displayCameraAngleSpinner: false,
      displayLastLoginSpinner: false
    }
  }

  componentDidMount() {
    document.documentElement.style.setProperty('--spinner-color', '#028BFE');
  }

  runScripts = (buttonName) => {
    const { token } = this.props.auth
    let payload = {}
    if(buttonName === 'lastVisit') {
      this.setState({isLastVisitDisabled: !this.state.isLastVisitDisabled, displayLastVisitSpinner: true})
      axios.post(
        '/api/test_scripts/run_last_visit_test/',
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `JWT ${token}`
          }
        }
      ).then(response => {
          if(buttonName === 'lastVisit') {
            this.setState({lastVisit: response.data, displayLastVisitSpinner: false})
          }
      }).catch(error => {
          toastr.error('Error', "Couldn't run script")
          }
        )
    } else if(buttonName === 'cameraAngles'){
      this.setState({isCameraAnglesDisabled: !this.state.isCameraAnglesDisabled, displayCameraAngleSpinner: true})
    } else {
      this.setState({isLastLoginDisabled: !this.state.isLastLoginDisabled, displayLastLoginSpinner: true}, () => console.log(this.state.lastLogin))
      axios.post(
        '/api/test_scripts/run_last_login_test/',
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `JWT ${token}`
          }
        }
      ).then(response => {
            this.setState({lastLogin: response.data, displayLastLoginSpinner: false})
          }
      ).catch(error => {
          toastr.error('Error', "Couldn't run script")
          }
        )
    }
  }

  render () {
    let {lastVisit, lastLogin} = this.state
    return (
      <Page history={this.props.history}>
      <div className='script-outer-container'>
        <div className='admin-location-header'>
          <Link to='/admin/locations'>
            <div className='admin-back-button'>
              <img src={arrow} alt='Back'/>
            </div>
          </Link>
          <h1>Test Scripts</h1>
        </div>
        <div>
        <div className='script-inner-container'>
          <div className='script-section-container'>
            <div className='script-section'>
                <div className='script-button'>
                  <Button
                    text='Last Visit'
                    type='viewNote'
                    onClick={() => this.runScripts('lastVisit')}
                    disabled={this.state.isLastVisitDisabled}
                  />
                  {this.state.displayLastVisitSpinner &&
                    <Spinner id='save-note' size='25px'/>
                  }
                </div>
                <div className='script-container'>
                {lastVisit &&
                  <div>
                    <div className='script-header'>
                      <p>Tested {lastVisit.number_of_locations} location(s)</p>
                      <p>Found <b>{lastVisit.number_of_failures}</b> potential problem(s):</p>
                    </div>
                    {lastVisit.failures.map((failure, index) => {
                        return (
                          <div className='script-bay' key={'failure' + index}>
                            <h3>{failure.location}</h3>
                            <h4>Bay {failure.bay}</h4>
                            <p>Last visit: {failure.last_visit}</p>
                          </div>
                        )
                      })
                    }
                  </div>
                }
                </div>
            </div>
            <div className='script-section'>
                <div className='script-button'>
                  <Button
                    text='Last Login'
                    type='viewNote'
                    onClick={() => this.runScripts('lastLogin')}
                    disabled={this.state.isLastLoginxwDisabled}
                  />
                  {this.state.displayLastLoginSpinner &&
                    <Spinner id='save-note' size='25px'/>
                  }
                </div>
                <div className='script-container'>
                {lastLogin &&
                  <div>
                    <div className='script-header'>
                      <p>Tested {lastLogin.number_of_locations} location(s)</p>
                      <p>Found <b>{lastLogin.number_of_failures}</b> potential problem(s):</p>
                    </div>
                    {lastLogin.failures.map((failure, index) => {
                        return (
                          <div className='script-bay' key={'failure' + index}>
                            <h3>{failure.location}</h3>
                            <h4>Email: {failure.email}</h4>
                            <p>Last login: {failure.last_login}</p>
                          </div>
                        )
                      })
                    }
                  </div>
                }
                </div>
            </div>
            <div className='script-section'>
                <div className='script-button'>
                  <Button
                    text='Camera Angles'
                    type='viewNote'
                    onClick={() => this.runScripts('cameraAngles')}
                    disabled={this.state.isCameraAnglesDisabled}
                  />
                  {this.state.displayCameraAngleSpinner &&
                    <Spinner id='save-note' size='25px'/>
                  }
                </div>
                <div className='script-container'>
                  <p> </p>
                </div>
            </div>
          </div>
          </div>
        </div>
      </div>
      </Page>
    )
  }
}

const mapStateToProps = (state) => {
  return state
}

export default connect(mapStateToProps)(TestScripts)



// WEBPACK FOOTER //
// ./src/pages/testScripts.js